import { gql } from 'react-apollo';

export const deactivateChurch = gql`
  mutation deactivateChurch($input: DeactivateChurchInput!) {
    deactivateChurch(input: $input)
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/mutations/deactivateChurch.js